/**
 * View for BotPlatform page
 */

define(function (require) {
    "use strict";

    var template = require("automation-templates/botplatform.tmpl");
    var BotPlatformView = {};

    LE.module('LEAutomation', function (LEAutomation, LE, Backbone, Marionette, $, _) {
        BotPlatformView = Marionette.ItemView.extend({
            template: template,
            className: 'automation-bot-platform',
            ui: {
                botplatform_iframe: '#botplatform-iframe'
            },

            initialize: function (options) {
                this.$el = options.el;
            },

            onRender: function(){
                $(this.$el).append(this.el);
                LEAutomation.contextModel.set('botplatform-iframe', this.ui.botplatform_iframe);
            }
        });
    });
    return BotPlatformView;
});
